import { Component, ViewChild } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { Subscription } from "rxjs";
import { MatDatepicker } from '@angular/material/datepicker';
import { MainDashboardResumeDTO } from "../../model/MainDashboardResumeDTO";
import { ControlPanelService } from "../../services/ControlPanel.service";
import { SessionService } from "src/app/features/shared/services/Session.service";

@Component({
  selector: "main-dashboard-page",
  templateUrl: "./main-dashboard-page.component.html",
  styleUrls: ["./main-dashboard-page.component.css"],
})
export class MainDashboardPageComponent {
  @ViewChild('picker') picker: MatDatepicker<Date>;

  dashboardDataResponse: MainDashboardResumeDTO = {
    totalUsers: 0,
    totalLocations: 0,
    totalLocationsByGPS: 0,
    totalGeofences: 0,
    totalLocations_Actives: 0,
    totalLocations_Inactives: 0,
    totalLocations_NoReport: 0,
    alarms: []
  };

  // dummyAlarms = [
  //   {
  //     categoryName: "Sistema",
  //     totalActivesByCategory: 1,
  //     date: "02/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Geocerca_Monitoreo",
  //     totalActivesByCategory: 4,
  //     date: "03/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Batería baja",
  //     totalActivesByCategory: 2,
  //     date: "05/01/2026",
  //     quantityPerDay: 2
  //   },
  //   {
  //     categoryName: "Batería baja",
  //     totalActivesByCategory: 2,
  //     date: "05/01/2026",
  //     quantityPerDay: 2
  //   },
  //   {
  //     categoryName: "Batería baja",
  //     totalActivesByCategory: 2,
  //     date: "06/01/2026",
  //     quantityPerDay: 2
  //   },
  //   {
  //     categoryName: "Velocidad",
  //     totalActivesByCategory: 3,
  //     date: "07/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Geocerca_Monitoreo",
  //     totalActivesByCategory: 4,
  //     date: "09/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Sistema",
  //     totalActivesByCategory: 2,
  //     date: "11/01/2026",
  //     quantityPerDay: 2
  //   },
  //   {
  //     categoryName: "Puerta abierta",
  //     totalActivesByCategory: 1,
  //     date: "13/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Temperatura alta",
  //     totalActivesByCategory: 2,
  //     date: "15/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Movimiento detectado",
  //     totalActivesByCategory: 3,
  //     date: "17/01/2026",
  //     quantityPerDay: 2
  //   },
  //   {
  //     categoryName: "Geocerca_Monitoreo",
  //     totalActivesByCategory: 4,
  //     date: "19/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Sistema",
  //     totalActivesByCategory: 1,
  //     date: "21/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Batería baja",
  //     totalActivesByCategory: 2,
  //     date: "23/01/2026",
  //     quantityPerDay: 2
  //   },
  //   {
  //     categoryName: "Velocidad",
  //     totalActivesByCategory: 3,
  //     date: "25/01/2026",
  //     quantityPerDay: 1
  //   },
  //   {
  //     categoryName: "Puerta abierta",
  //     totalActivesByCategory: 1,
  //     date: "27/01/2026",
  //     quantityPerDay: 1
  //   }
  // ];

  selectedMonthDisplay = "";
  selectedDate: Date = null;
  selectedMonth: number = 1;
  minDate: Date = null;
  maxDate: Date = null;

  subscription_getResumeData: Subscription;

  constructor(private controlPanelService: ControlPanelService, private sessionService: SessionService) {
    this.sessionService.setIsExternalMap(false);
  }

  ngOnInit() {
    const now = new Date();
    this.selectedMonthDisplay = this.getLongDate(now);

    this.selectedDate = new Date(now.getFullYear(), now.getMonth(), 1);
    this.selectedMonth = now.getMonth() + 1;
    this.minDate = new Date(now.getFullYear(), 0, 1);
    this.maxDate = new Date(now.getFullYear(), 11, 31);
  }

  ngAfterViewInit(): void {
    this.EndSubscriptions();
    this.subscription_getResumeData =this.controlPanelService.getResume(this.selectedMonth).subscribe({
      next: (data) => {
        if (data.isSuccess) {
          // data.result.alarms = this.dummyAlarms;
          this.dashboardDataResponse = data.result;
        } else {
          Sentry.captureMessage('MainDashboardPage.ngAfterViewInit: isSuccess false', { level: 'warning', extra: { response: data } });
        }
      },
      error: (error) => {
        // TODO marca para complete despues
        console.error('Error al obtener el panel de control', error);
      }
    });
  }

  ngOnDestroy(): void {
    this.EndSubscriptions();
  }

  EndSubscriptions() {
    if (this.subscription_getResumeData)
      this.subscription_getResumeData.unsubscribe();
  }

  getLongDate(date: Date ): string {
    if (!date) 
      return '';
    return date.toLocaleDateString('es-ES', { month: 'long' });
  }

  monthPick(input: Date, datepicker: MatDatepicker<Date>) {
    const year = input.getFullYear();
    const month = input.getMonth();
    this.selectedDate = new Date(year, month, 1);
    this.selectedMonth = month + 1;
    this.selectedMonthDisplay = this.getLongDate(this.selectedDate);
    datepicker.close();

    this.EndSubscriptions();
    this.subscription_getResumeData =this.controlPanelService.getResume(this.selectedMonth).subscribe({
      next: (data) => {
        if (data.isSuccess) {
          // data.result.alarms = this.dummyAlarms;
          this.dashboardDataResponse = data.result;
        }else{
          console.error('Error al obtener el panel de control', data.message);
          Sentry.captureMessage('MainDashboardPage.monthPick: isSuccess false', { level: 'warning', extra: { response: data } });
          this.dashboardDataResponse = {
            totalUsers: 0,
            totalLocations: 0,
            totalLocationsByGPS: 0,
            totalGeofences: 0,
            totalLocations_Actives: 0,
            totalLocations_Inactives: 0,
            totalLocations_NoReport: 0,
            alarms: []
          };
        }
      },
      error: (error) => {
        console.error('Error al obtener el panel de control', error);
      }
    });
  }

  onMonthSelected(monthValue: number): void {
    const year = this.selectedDate.getFullYear();
    this.selectedDate = new Date(year, monthValue - 1, 1);
    this.selectedMonth = monthValue;
    this.selectedMonthDisplay = this.getLongDate(this.selectedDate);

    this.EndSubscriptions();
    this.subscription_getResumeData = this.controlPanelService.getResume(this.selectedMonth).subscribe({
      next: (data) => {
        if (data.isSuccess) {
          
          // data.result.alarms = this.dummyAlarms;
          this.dashboardDataResponse = data.result;
        } else {
          console.error('Error al obtener el panel de control', data.message);
          Sentry.captureMessage('MainDashboardPage.onMonthSelected: isSuccess false', { level: 'warning', extra: { response: data } });
          this.dashboardDataResponse = {
            totalUsers: 0,
            totalLocations: 0,
            totalLocationsByGPS: 0,
            totalGeofences: 0,
            totalLocations_Actives: 0,
            totalLocations_Inactives: 0,
            totalLocations_NoReport: 0,
            alarms: []
          };
        }
      },
      error: (error) => {
        console.error('Error al obtener el panel de control', error);
      }
    });
  }

}
